module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/hero-mobile@2x.15234e9.jpg";